<template>
    <div>
        <breadCrumb 
            :icon="'fa-box-open'"
            :category="$t(`sideNav.navSalonMenu`)"
            :subCategory="$t(`subMenu.salon_menu_product`)"
            :subSubCategory="''">
        </breadCrumb>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in tab" :key="t.id">
                <a class="nav-link  bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="renderTabs(t.id)">{{t.text}}</a>
            </li>
        </ul>
        <div class="tab-content mt-5">
            <productList ref="productList" :class="{'active': selectedTab === 'main'}" class="tab-pane"></productList>
            <productSubCategoryList ref="productSubCategoryList" :class="{'active': selectedTab === 'sub'}" class="tab-pane"></productSubCategoryList>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import ProductList from './Product_List'
import ProductSubCategoryList from './Product_SubCategoryList'
import {setSalonMenuTabLabel} from './../../../../assets/js/dashboard/dashboard'

export default {
    name: 'menuProduct',
    components:{
        ProductList, ProductSubCategoryList, BreadCrumb
    },
    data(){
        return{
            tab: [], selectedTab: 'main'
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setTabLabel()
        }
    },
    methods:{
        renderTabs(id){
            this.selectedTab = id;
            this.$refs.productList.addProductToggle = false;
            this.$refs.productSubCategoryList.addSubToggle = false;
        },
        setTabLabel(){
            this.tab = setSalonMenuTabLabel(this.$i18n.t('subMenu.salon_menu_product'), this.$i18n.t('header.subCategory', {'item': this.$i18n.t('subMenu.salon_menu_product')}))
        }
    },
    mounted(){
        let $vm = this
        $vm.setTabLabel()
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>